
import { LucideIcon } from "lucide-react";
import { motion } from "framer-motion";
import { type MouseEvent } from "react";

interface ServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  badge?: string;
}

function handleSpotlight(e: MouseEvent<HTMLDivElement>) {
  const rect = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--spot-x", `${e.clientX - rect.left}px`);
  e.currentTarget.style.setProperty("--spot-y", `${e.clientY - rect.top}px`);
}

export function ServiceCard({ title, description, icon: Icon, badge }: ServiceCardProps) {
  return (
    <motion.div
      className="bento-card h-full flex flex-col group cursor-pointer"
      onMouseMove={handleSpotlight}
      whileHover={{ y: -6, transition: { duration: 0.3, ease: "easeOut" } }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {badge && <span className="eyebrow absolute top-6 right-6">{badge}</span>}

      <div className="relative mb-6">
        <div className="rounded-2xl bg-gradient-to-br from-primary/15 to-blue-500/15 p-3.5 w-fit border border-border/60">
          <Icon className="h-7 w-7 text-primary group-hover:scale-110 transition-transform duration-300" />
        </div>
      </div>

      <h3 className="text-xl font-semibold mb-3 flex-shrink-0 group-hover:text-primary transition-colors duration-300">
        {title}
      </h3>

      <p className="text-muted-foreground flex-grow text-sm leading-relaxed">
        {description}
      </p>

      <div className="mt-6 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
    </motion.div>
  );
}
